module.exports = __webpack_public_path__ + "static/media/JC.b9743a69.svg";